var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEtFs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.257 25.781c.982 0 1.806-.825 1.739-1.804C54.111 11.144 43.856.889 31.024.004A1.43 1.43 0 0030.912 0c-.93 0-1.693.8-1.693 1.744V25.78h24.038zm-1.898-3.437H32.656V3.642c9.588 1.483 17.218 9.114 18.703 18.702zM26.108 54.998a25.58 25.58 0 0014.53-4.73c.849-.602.904-1.851.169-2.587L24.063 30.937V5.447c0-.948-.772-1.741-1.691-1.741-.074 0-.15.005-.227.016C9.345 5.532-.44 16.715.015 30.118.48 43.778 12.158 55 25.795 55l.313-.002zm-.314-3.436c-11.713 0-21.946-9.874-22.343-21.561-.366-10.756 6.897-20.091 17.174-22.5v24.86l1.007 1.006 15.236 15.237a22.096 22.096 0 01-10.804 2.956l-.27.002zM49.43 48.43c.41 0 .819-.145 1.136-.444a25.72 25.72 0 007.855-15.131c.145-1.016-.699-1.918-1.725-1.918h-25.49l16.976 16.976c.286.285.845.516 1.248.517zm-.029-4.16l-9.895-9.895h15.133a22.425 22.425 0 01-5.238 9.896z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

export default SvgEtFs;